// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fSL7","content":"styles_content__1Ate5","tableWrap":"styles_tableWrap__3zY3y"};